const hasOptionalPractice = (pathname = '') =>
  pathname.includes('optional-practice');

export default hasOptionalPractice;
